<div>
    <h3>About</h3>
    <p>Pending</p>

    <h3>Deployment</h3>
    <p>
        The backend is deployed on an Amazon EC2 instance, using nginx for
        redirects and PM2 for managing node instances. Domain hosted on Amazon
        Route 53.
    </p>
</div>
